export default __webpack_public_path__ + "static/media/play_3.fecc31da.jpg";